import { Brick, registerBrick } from 'olympe';

export default class MassUpdateTabPanel extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array<*>} properties
     * @return {Element}
     */
    render($, properties) {
        // Write your code here. This method must return a DOM element.
        // If using React take a look at the ReactBrick class.
        // Check https://olympe.support for documentation.
        // Check https://github.com/olympeio/CORE for examples.
        //
        // This method is executed only once by default.
        // Override `setupExecution()` to change the behavior and control the `properties` parameter.
    }
}

registerBrick('019bb2eef685d21228f6', MassUpdateTabPanel);
